import { render, staticRenderFns } from "./TutorialConfig.vue?vue&type=template&id=66110cfa&scoped=true"
import script from "./TutorialConfig.vue?vue&type=script&lang=js"
export * from "./TutorialConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66110cfa",
  null
  
)

export default component.exports